<div>
	<p-table
		#mydt
		[value]="lstTable"
		[loading]="IsLoading() == true"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="lstSelected"
		dataKey="GroupID"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>
				<!--GroupName-->
				<th>
					<p-columnFilter type="text" field="GroupName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StudentCount-->
				<th></th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>
				<th pSortableColumn="GroupName">Group<p-sortIcon field="GroupName"></p-sortIcon></th>
				<th pSortableColumn="StudentCount">Student Count<p-sortIcon field="StudentCount"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Group>
			<tr [pSelectableRow]="Group">
				<td>
					<p-tableCheckbox [disabled]="IsLoading() == true" [pSelectableRow]="Group" [value]="Group"></p-tableCheckbox>
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Group.GroupName }}
				</td>
				<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Group.StudentCount }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<div class="Buttons">
	<button class="btn btn-primary" (click)="onAdd()">Add</button>
	<button class="btn btn-warning" (click)="onClose()">Cancel</button>
</div>
